export default function CloseIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 10.5859L16.5859 6H18V7.41406L13.4141 12L18 16.5859V18H16.5859L12 13.4141L7.41406 18H6V16.5859L10.5859 12L6 7.41406V6H7.41406L12 10.5859Z"
        fill="var(--text-primary-color)"
      />
    </svg>
  );
}
